
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/leaddyno-alternative",
      function () {
        return require("private-next-pages/leaddyno-alternative.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/leaddyno-alternative"])
      });
    }
  